export default function () {
}

/**************************************************
 * イベントハンドラ
 *************************************************/

/**************************************************
 * 外部コール
 *************************************************/
/**
 * 一時保存ファイルを削除する
 * @param target
 * @param url
 */
export function deleteTemporary(target, url) {
    appUtil.deleteAction(url).then(() => {
        deleteExists(target);
    });
}

/**
 * 既存ファイルを削除する
 * @param target
 */
export function deleteExists(target) {
    $(target).closest('.row').remove();
}

/**************************************************
 * 内部処理
 *************************************************/
